import { useEffect } from "react";

import { ExperimentType } from "../Types";
import { CREATE_KEY } from "../Shared/shared.consts";
import { useNavigateEv2Experiments } from "./UseNavigateToEv2Experiments";
import { useEv2ExperimentParams } from "./UseCurrentExtension";

export function useValidateExperimentParam(
  experiments: ExperimentType[] | undefined,
) {
  const { experimentName } = useEv2ExperimentParams();
  const { navigateToRoot } = useNavigateEv2Experiments();

  useEffect(() => {
    if (experimentName === CREATE_KEY) {
      return;
    }
    if (experimentName && experiments) {
      const isValidExperiment = experiments.find(
        (experiment) => experiment.featureKey === experimentName,
      );
      if (!isValidExperiment) {
        navigateToRoot();
      }
    }
  }, [experimentName, experiments, navigateToRoot]);
}
